@if (text(); as text) {
    @if (tooltip(); as tooltip) {
        @if (options().icon; as icon) {
            {{ text }}
            <fa-icon
                [icon]="icon"
                class="ms-1"
                [ngbTooltip]="tooltipContent"
                [tooltipClass]="tooltip.tooltipClass"
                container="body"
            />
        } @else {
            <span
                [ngbTooltip]="tooltipContent"
                [tooltipClass]="tooltip.tooltipClass"
                container="body"
            >
                {{ text }}
            </span>
        }
        <ng-template #tooltipContent>
            <ng-container *ngComponentOutlet="tooltip.component; inputs: tooltip.inputs" />
        </ng-template>
    } @else {
        {{ text }}
        @if (options().icon; as icon) {
            <fa-icon [icon]="icon" class="ms-1" />
        }
    }
} @else if (options().emptyLabel; as emptyLabel) {
    {{ emptyLabel | translate }}
} @else {
    –
}
